import { HighlightedTextLabel } from '../ProductListModal.styled';

export const normalizeText = (text: string) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const createAccentedArray = (firstArray: string[], str: string) => {
  let currentIndex = 0;
  const accentedArray: string[] = [];

  firstArray.forEach((text) => {
    const textLength = text.length;

    const accentedText = str.slice(currentIndex, currentIndex + textLength);
    accentedArray.push(accentedText);

    currentIndex += textLength;
  });

  return accentedArray;
};

export const highlightKeyword = (text: string, highlight: string) => {
  if (!highlight.trim()) {
    return text;
  }

  // Escape special characters in the highlight string
  const escapeRegExp = (string: string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const escapedHighlight = normalizeText(escapeRegExp(highlight));

  // Create a regular expression to find matches case-insensitively
  const regex = new RegExp(`(${escapedHighlight})`, 'gi');

  // Split the text into highlightedText that match and don't match the search term
  const highlightedText = normalizeText(text)
    .split(regex)
    .filter((text) => text !== '');

  // Map over the highlightedText, highlighting the matches
  return createAccentedArray(highlightedText, text).map((text, index) =>
    normalizeText(text) === normalizeText(highlight) ? (
      <HighlightedTextLabel key={index}>{text}</HighlightedTextLabel>
    ) : (
      text
    ),
  );
};
